import { render, staticRenderFns } from "./ppanelImport.vue?vue&type=template&id=f3c8d95c"
import script from "./ppanelImport.vue?vue&type=script&lang=js"
export * from "./ppanelImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports